/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_Cta_LeadInputs */

const en_mk_cmp_page_cta_lead = /** @type {(inputs: Mk_Cmp_Page_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng puts agents on the same board as marketing, sales, finance, HR, and tech — with nothing for anyone to install.`)
};

const id_mk_cmp_page_cta_lead = /** @type {(inputs: Mk_Cmp_Page_Cta_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng menaruh agen di papan kerja yang sama dengan divisi marketing, sales, finance, HR, sampai tech — tanpa siapa pun perlu instal apa pun.`)
};

/**
* | output |
* | --- |
* | "KerjaBareng puts agents on the same board as marketing, sales, finance, HR, and tech — with nothing for anyone to install." |
*
* @param {Mk_Cmp_Page_Cta_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_cta_lead = /** @type {((inputs?: Mk_Cmp_Page_Cta_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_Cta_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_cta_lead(inputs)
	return en_mk_cmp_page_cta_lead(inputs)
});